import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"; 
import styles from "./PatientCard.scss";

const PatientCard = ({ patientName, patientUrl, totalNumberInvoices }) => {
    return (
        <Link to={patientUrl}>
            <div className={styles.root}>
                <div className="align-center margin-bottom-sm"><i className="fa-regular fa-heart margin-right-x-sm"></i><p as="h2" className={styles.heading}>{patientName}</p></div>
                <p className={styles.invoices}>Total Invoices: {totalNumberInvoices}</p>
                <p className={styles.link}>View History<i className="fa fa-arrow-right fa-fw" /></p>
            </div>
        </Link>
    );
};

PatientCard.propTypes = {
    patientName: PropTypes.string.isRequired,
    patientUrl: PropTypes.string.isRequired,
    totalNumberInvoices: PropTypes.number.isRequired,
};

export default PatientCard;